import { gql } from '@apollo/client'

export const CREATE_RAW_MATERIAL = gql`
  mutation CreateRawMaterial($data: CreateRawMaterialInput!) {
    createRawMaterial(data: $data) {
      id
      name
      type
      unit
      output_quantity
      cost_per_unit_millicents
      current_cost_per_unit_millicents
    }
  }
`

export const ADD_RECIPE_INGREDIENT = gql`
  mutation AddRecipeIngredient($parentId: Int!, $data: RecipeIngredientInput!) {
    addRecipeIngredient(parentId: $parentId, data: $data) {
      id
      child_id
      quantity
      child { id name unit type }
    }
  }
`

export const REMOVE_RECIPE_INGREDIENT = gql`
  mutation RemoveRecipeIngredient($id: Int!) {
    removeRecipeIngredient(id: $id)
  }
`

export const SET_RECIPE_INGREDIENTS = gql`
  mutation SetRecipeIngredients($parentId: Int!, $ingredients: [RecipeIngredientInput!]!) {
    setRecipeIngredients(parentId: $parentId, ingredients: $ingredients) {
      id
      child_id
      quantity
      child { id name unit type }
    }
  }
`

export const UPDATE_RAW_MATERIAL = gql`
  mutation UpdateRawMaterial($id: Int!, $data: UpdateRawMaterialInput!) {
    updateRawMaterial(id: $id, data: $data) {
      id
      name
      notes
      active
      track_inventory
    }
  }
`

export const DELETE_RAW_MATERIAL = gql`
  mutation DeleteRawMaterial($id: Int!) {
    deleteRawMaterial(id: $id)
  }
`

export const SET_RAW_MATERIAL_PRICE = gql`
  mutation SetRawMaterialPrice($id: Int!, $data: SetRawMaterialPriceInput!) {
    setRawMaterialPrice(id: $id, data: $data) {
      id
      cost_per_unit_millicents
      effective_from
    }
  }
`


export const UPSERT_VARIANT_INGREDIENT = gql`
  mutation UpsertVariantIngredient($variantId: Int!, $ingredient: VariantIngredientInput!) {
    upsertVariantIngredient(variantId: $variantId, ingredient: $ingredient) {
      id
      raw_material_id
      quantity
      raw_material {
        id
        name
        unit
        current_cost_per_unit_millicents
      }
    }
  }
`

export const REMOVE_VARIANT_INGREDIENT = gql`
  mutation RemoveVariantIngredient($variantId: Int!, $rawMaterialId: Int!) {
    removeVariantIngredient(variantId: $variantId, rawMaterialId: $rawMaterialId)
  }
`

export const CREATE_OPTION_ITEM_INGREDIENT = gql`
  mutation CreateOptionItemIngredient($optionItemId: Int!, $data: OptionItemIngredientInput!) {
    createOptionItemIngredient(optionItemId: $optionItemId, data: $data) {
      id
      variant_id
      raw_material_id
      quantity
    }
  }
`

export const UPDATE_OPTION_ITEM_INGREDIENT = gql`
  mutation UpdateOptionItemIngredient($id: Int!, $data: UpdateOptionItemIngredientInput!) {
    updateOptionItemIngredient(id: $id, data: $data) {
      id
      quantity
    }
  }
`

export const DELETE_OPTION_ITEM_INGREDIENT = gql`
  mutation DeleteOptionItemIngredient($id: Int!) {
    deleteOptionItemIngredient(id: $id)
  }
`

